// ============================================================
// Clínica — SEED de dados (fonte única in-memory)
// ------------------------------------------------------------
// Fase 1: consumido diretamente pelas views como fixtures.
// Fase 2: passa a alimentar os stub-services (src/services/clinica/*),
//   que clonam este seed num "db" mutável (src/services/clinica/db.js) e
//   expõem uma API async. As views deixam de importar daqui e passam a
//   despachar ações/serviços. Este arquivo é a semente do "banco".
//
// Valores monetários em CENTAVOS (integer). Nomes/valores reproduzem os
// HTMLs do handoff para manter fidelidade de conteúdo.
// ============================================================

// ---------- Clínicas & unidades ----------
export const clinics = [{ id: 1, name: "Clínica Vida+", unitIds: [1, 2, 3] }];

export const clinicContext = {
  id: 1,
  name: "Clínica Vida+",
  initials: "V+",
  unit: "Unidade Centro",
  doctorCount: 5
};

export const units = [
  {
    id: 1,
    name: "Unidade Centro",
    clinicId: 1,
    doctorCount: 5,
    address: "Av. Paulista, 1000 · Centro"
  },
  {
    id: 2,
    name: "Unidade Zona Sul",
    clinicId: 1,
    doctorCount: 3,
    address: "R. das Acácias, 250 · Zona Sul"
  },
  {
    id: 3,
    name: "Online",
    clinicId: 1,
    doctorCount: 5,
    address: "Teleconsulta"
  }
];

// ---------- Operadores (usuários da clínica) ----------
export const operators = [
  {
    id: 1,
    name: "Camila Souza",
    initials: "CS",
    email: "camila@clinicavidamais.com.br",
    role: "atendimento",
    roleLabel: "Atendimento",
    clinicId: 1,
    unitId: 1,
    clinicName: "Clínica Vida+",
    status: "ativo"
  },
  {
    id: 2,
    name: "Rafael Moura",
    initials: "RM",
    email: "rafael@clinicavidamais.com.br",
    role: "admin",
    roleLabel: "Administrador",
    clinicId: 1,
    unitId: null,
    clinicName: "Clínica Vida+",
    status: "ativo"
  },
  {
    id: 3,
    name: "Beatriz Lima",
    initials: "BL",
    email: "beatriz@clinicavidamais.com.br",
    role: "atendimento",
    roleLabel: "Atendimento",
    clinicId: 1,
    unitId: 2,
    clinicName: "Clínica Vida+",
    status: "convidado"
  }
];

// Operador logado por padrão no protótipo (Camila · Atendimento)
export const operator = operators[0];

// ---------- Especialidades ----------
export const specialties = [
  { id: 1, name: "Cardiologia", defaultDuration: 30 },
  { id: 2, name: "Ortopedia", defaultDuration: 30 },
  { id: 3, name: "Dermatologia", defaultDuration: 20 },
  { id: 4, name: "Clínico geral", defaultDuration: 20 },
  { id: 5, name: "Pediatria", defaultDuration: 30 },
  { id: 6, name: "Endocrinologia", defaultDuration: 30 }
];

// ---------- Corpo clínico ----------
export const doctors = [
  {
    id: 1,
    name: "Dra. Renata Alves",
    initials: "RA",
    avatarClass: "av-rose",
    crm: "CRM 12345",
    uf: "SP",
    specialty: "Cardiologia",
    specialtyShort: "Cardio",
    appointmentsMonth: 62,
    occupation: 86,
    status: "ativo",
    statusLabel: "Ativo",
    transferPct: 70,
    unitId: 1,
    modality: "Híbrido",
    consultPrice: 35000,
    defaultDuration: 30
  },
  {
    id: 2,
    name: "Dr. Marcos Tavares",
    initials: "MT",
    avatarClass: "av-blue",
    crm: "CRM 23456",
    uf: "SP",
    specialty: "Ortopedia",
    specialtyShort: "Orto",
    appointmentsMonth: 48,
    occupation: 74,
    status: "ativo",
    statusLabel: "Ativo",
    transferPct: 70,
    unitId: 1,
    modality: "Presencial",
    consultPrice: 32000,
    defaultDuration: 30
  },
  {
    id: 3,
    name: "Dra. Helena Costa",
    initials: "HC",
    avatarClass: "av-green",
    crm: "CRM 34567",
    uf: "SP",
    specialty: "Dermatologia",
    specialtyShort: "Dermato",
    appointmentsMonth: 41,
    occupation: 69,
    status: "ativo",
    statusLabel: "Ativo",
    transferPct: 70,
    unitId: 1,
    modality: "Híbrido",
    consultPrice: 30000,
    defaultDuration: 20
  },
  {
    id: 4,
    name: "Dr. Paulo Ribeiro",
    initials: "PR",
    avatarClass: "av-amber",
    crm: "CRM 45678",
    uf: "SP",
    specialty: "Clínico geral",
    specialtyShort: "Clínico",
    appointmentsMonth: 39,
    occupation: 71,
    status: "ativo",
    statusLabel: "Ativo",
    transferPct: 70,
    unitId: 1,
    modality: "Online",
    consultPrice: 28000,
    defaultDuration: 20
  },
  {
    id: 5,
    name: "Dra. Júlia Mendes",
    initials: "JM",
    avatarClass: "av-slate",
    crm: "CRM 56789",
    uf: "SP",
    specialty: "Pediatria",
    specialtyShort: "Pediatria",
    appointmentsMonth: 28,
    occupation: 58,
    status: "ativo",
    statusLabel: "Ativo",
    transferPct: 70,
    unitId: 1,
    modality: "Híbrido",
    consultPrice: 30000,
    defaultDuration: 30
  },
  {
    id: 6,
    name: "Dr. Lucas Ferraz",
    initials: "LF",
    avatarClass: "av-blue",
    crm: "CRM 67890",
    uf: "SP",
    specialty: "Endocrinologia",
    specialtyShort: "Endócrino",
    appointmentsMonth: 0,
    occupation: 0,
    status: "onboarding",
    statusLabel: "Onboarding",
    transferPct: 70,
    unitId: 2,
    modality: "Online",
    consultPrice: 32000,
    defaultDuration: 30
  }
];

// ---------- Pacientes ----------
// daysSinceLast serve para os cortes de "sem retorno" (30/60/90).
export const patients = [
  {
    id: 1,
    name: "Maria Silva",
    initials: "MS",
    avatarClass: "av-blue",
    contact: "(11) 98888-1010",
    email: "maria.silva@email.com",
    doctorId: 1,
    status: "ativo",
    statusLabel: "Ativo",
    lastAppointment: "2026-06-12",
    daysSinceLast: 22,
    unitId: 1
  },
  {
    id: 2,
    name: "José Carlos B.",
    initials: "JC",
    avatarClass: "av-rose",
    contact: "(11) 98888-2020",
    email: "jose.carlos@email.com",
    doctorId: 2,
    status: "ativo",
    statusLabel: "Ativo",
    lastAppointment: "2026-06-01",
    daysSinceLast: 33,
    unitId: 1
  },
  {
    id: 3,
    name: "Paulo Lima",
    initials: "PL",
    avatarClass: "av-green",
    contact: "(11) 98888-3030",
    email: "paulo.lima@email.com",
    doctorId: 3,
    status: "ativo",
    statusLabel: "Ativo",
    lastAppointment: "2026-05-20",
    daysSinceLast: 45,
    unitId: 1
  },
  {
    id: 4,
    name: "Ana Beatriz R.",
    initials: "AB",
    avatarClass: "av-amber",
    contact: "(11) 98888-4040",
    email: "ana.beatriz@email.com",
    doctorId: 4,
    status: "sem_retorno",
    statusLabel: "Sem retorno",
    lastAppointment: "2026-04-28",
    daysSinceLast: 67,
    unitId: 1
  },
  {
    id: 5,
    name: "Roberto Nunes",
    initials: "RN",
    avatarClass: "av-slate",
    contact: "(11) 98888-5050",
    email: "roberto.nunes@email.com",
    doctorId: 5,
    status: "sem_retorno",
    statusLabel: "Sem retorno",
    lastAppointment: "2026-03-30",
    daysSinceLast: 96,
    unitId: 1
  },
  {
    id: 6,
    name: "Fernanda Dias",
    initials: "FD",
    avatarClass: "av-rose",
    contact: "(11) 98888-6060",
    email: "fernanda.dias@email.com",
    doctorId: 3,
    status: "novo",
    statusLabel: "Novo",
    lastAppointment: "2026-07-03",
    daysSinceLast: 1,
    unitId: 1
  },
  {
    id: 7,
    name: "Carlos Eduardo M.",
    initials: "CE",
    avatarClass: "av-blue",
    contact: "(11) 98888-7070",
    email: "carlos.eduardo@email.com",
    doctorId: 2,
    status: "novo",
    statusLabel: "Novo",
    lastAppointment: "2026-07-02",
    daysSinceLast: 2,
    unitId: 1
  },
  {
    id: 8,
    name: "Letícia Torres",
    initials: "LT",
    avatarClass: "av-green",
    contact: "(11) 98888-8080",
    email: "leticia.torres@email.com",
    doctorId: 5,
    status: "novo",
    statusLabel: "Novo",
    lastAppointment: "2026-07-01",
    daysSinceLast: 3,
    unitId: 1
  },
  {
    id: 9,
    name: "Gabriel Santos",
    initials: "GS",
    avatarClass: "av-amber",
    contact: "(11) 98888-9090",
    email: "gabriel.santos@email.com",
    doctorId: 4,
    status: "ativo",
    statusLabel: "Ativo",
    lastAppointment: "2026-06-30",
    daysSinceLast: 4,
    unitId: 1
  },
  {
    id: 10,
    name: "Bianca Lopes",
    initials: "BL",
    avatarClass: "av-rose",
    contact: "(11) 97777-1111",
    email: "bianca.lopes@email.com",
    doctorId: 1,
    status: "sem_retorno",
    statusLabel: "Sem retorno",
    lastAppointment: "2026-01-15",
    daysSinceLast: 170,
    unitId: 2
  },
  {
    id: 11,
    name: "Hugo Almeida",
    initials: "HA",
    avatarClass: "av-slate",
    contact: "(11) 97777-2222",
    email: "hugo.almeida@email.com",
    doctorId: 2,
    status: "inativo",
    statusLabel: "Inativo",
    lastAppointment: "2025-11-10",
    daysSinceLast: 236,
    unitId: 2
  },
  {
    id: 12,
    name: "Sofia Martins",
    initials: "SM",
    avatarClass: "av-green",
    contact: "(11) 97777-3333",
    email: "sofia.martins@email.com",
    doctorId: 5,
    status: "ativo",
    statusLabel: "Ativo",
    lastAppointment: "2026-06-25",
    daysSinceLast: 9,
    unitId: 1
  }
];

// ---------- Timeline & notas (perfil do paciente) ----------
export const timelineEvents = [
  {
    id: 1,
    patientId: 1,
    type: "consulta",
    date: "2026-06-12",
    description:
      "Consulta de rotina com Dra. Renata Alves — pressão controlada."
  },
  {
    id: 2,
    patientId: 1,
    type: "receita",
    date: "2026-06-12",
    description: "Losartana 50mg — uso contínuo."
  },
  {
    id: 3,
    patientId: 1,
    type: "atestado",
    date: "2026-05-02",
    description: "Atestado de 2 dias emitido."
  },
  {
    id: 4,
    patientId: 1,
    type: "contato",
    date: "2026-04-20",
    description: "Contato telefônico para confirmar retorno."
  },
  {
    id: 5,
    patientId: 1,
    type: "retorno",
    date: "2026-03-15",
    description: "Retorno agendado e realizado."
  }
];

export const notes = [
  {
    id: 1,
    patientId: 1,
    author: "Camila Souza",
    date: "2026-06-12",
    text: "Paciente prefere contato por WhatsApp no período da tarde."
  },
  {
    id: 2,
    patientId: 1,
    author: "Rafael Moura",
    date: "2026-05-02",
    text: "Convênio confirmado. Sem pendências financeiras."
  }
];

// ---------- Agenda (consultas) ----------
// datetime ISO; usadas na grade da agenda e no dashboard.
export const appointments = [
  {
    id: 101,
    patientId: 1,
    doctorId: 1,
    datetime: "2026-06-19T08:00",
    duration: 30,
    status: "realizada",
    price: 35000,
    modality: "Presencial",
    type: "Retorno"
  },
  {
    id: 102,
    patientId: 2,
    doctorId: 2,
    datetime: "2026-06-19T08:00",
    duration: 30,
    status: "confirmada",
    price: 32000,
    modality: "Presencial",
    type: "Consulta"
  },
  {
    id: 103,
    patientId: 3,
    doctorId: 3,
    datetime: "2026-06-19T11:00",
    duration: 20,
    status: "agendada",
    price: 30000,
    modality: "Presencial",
    type: "Consulta"
  },
  {
    id: 104,
    patientId: 4,
    doctorId: 4,
    datetime: "2026-06-19T14:00",
    duration: 20,
    status: "agendada",
    price: 28000,
    modality: "Online",
    type: "Consulta"
  },
  {
    id: 105,
    patientId: 5,
    doctorId: 5,
    datetime: "2026-06-19T15:30",
    duration: 30,
    status: "agendada",
    price: 30000,
    modality: "Presencial",
    type: "Pediatria"
  },
  {
    id: 106,
    patientId: 10,
    doctorId: 1,
    datetime: "2026-06-19T09:00",
    duration: 30,
    status: "aguardando_pgto",
    price: 35000,
    modality: "Presencial",
    type: "Consulta"
  },
  {
    id: 107,
    patientId: 9,
    doctorId: 4,
    datetime: "2026-06-19T11:00",
    duration: 20,
    status: "confirmada",
    price: 28000,
    modality: "Online",
    type: "Consulta"
  }
];

// Consultas aguardando confirmação (tela Confirmações)
export const confirmationsQueue = [
  {
    id: 201,
    patientId: 3,
    patientName: "Paulo Lima",
    initials: "PL",
    avatarClass: "av-green",
    doctorId: 3,
    doctorName: "Dra. Helena Costa",
    datetime: "2026-06-20T09:30",
    when: "Amanhã · 09:30",
    status: "aguardando_confirmacao",
    phone: "(11) 98888-3030"
  },
  {
    id: 202,
    patientId: 5,
    patientName: "Roberto Nunes",
    initials: "RN",
    avatarClass: "av-slate",
    doctorId: 5,
    doctorName: "Dra. Júlia Mendes",
    datetime: "2026-06-20T15:30",
    when: "Amanhã · 15:30",
    status: "aguardando_confirmacao",
    phone: "(11) 98888-5050"
  },
  {
    id: 203,
    patientId: 4,
    patientName: "Ana Beatriz R.",
    initials: "AB",
    avatarClass: "av-amber",
    doctorId: 4,
    doctorName: "Dr. Paulo Ribeiro",
    datetime: "2026-06-21T14:00",
    when: "Sáb · 14:00",
    status: "aguardando_confirmacao",
    phone: "(11) 98888-4040"
  },
  {
    id: 204,
    patientId: 9,
    patientName: "Gabriel Santos",
    initials: "GS",
    avatarClass: "av-amber",
    doctorId: 1,
    doctorName: "Dra. Renata Alves",
    datetime: "2026-06-22T10:00",
    when: "Seg · 10:00",
    status: "aguardando_confirmacao",
    phone: "(11) 98888-9090"
  },
  {
    id: 205,
    patientId: 12,
    patientName: "Sofia Martins",
    initials: "SM",
    avatarClass: "av-green",
    doctorId: 5,
    doctorName: "Dra. Júlia Mendes",
    datetime: "2026-06-22T16:00",
    when: "Seg · 16:00",
    status: "aguardando_confirmacao",
    phone: "(11) 97777-3333"
  },
  {
    id: 206,
    patientId: 2,
    patientName: "José Carlos B.",
    initials: "JC",
    avatarClass: "av-rose",
    doctorId: 2,
    doctorName: "Dr. Marcos Tavares",
    datetime: "2026-06-23T08:30",
    when: "Ter · 08:30",
    status: "aguardando_confirmacao",
    phone: "(11) 98888-2020"
  },
  {
    id: 207,
    patientId: 1,
    patientName: "Maria Silva",
    initials: "MS",
    avatarClass: "av-blue",
    doctorId: 1,
    doctorName: "Dra. Renata Alves",
    datetime: "2026-06-23T09:00",
    when: "Ter · 09:00",
    status: "aguardando_confirmacao",
    phone: "(11) 98888-1010"
  },
  {
    id: 208,
    patientId: 6,
    patientName: "Fernanda Dias",
    initials: "FD",
    avatarClass: "av-rose",
    doctorId: 3,
    doctorName: "Dra. Helena Costa",
    datetime: "2026-06-24T13:30",
    when: "Qua · 13:30",
    status: "aguardando_confirmacao",
    phone: "(11) 98888-6060"
  }
];

// Fila de reagendamento
export const reschedulesQueue = [
  {
    id: 301,
    patientId: 4,
    patientName: "Ana Beatriz R.",
    initials: "AB",
    avatarClass: "av-amber",
    doctorId: 4,
    doctorName: "Dr. Paulo Ribeiro",
    reason: "Paciente solicitou",
    requestedAt: "2026-06-18",
    oldSlot: "18/06 14:00",
    status: "pendente",
    suggested: null
  },
  {
    id: 302,
    patientId: 10,
    patientName: "Bianca Lopes",
    initials: "BL",
    avatarClass: "av-rose",
    doctorId: 1,
    doctorName: "Dra. Renata Alves",
    reason: "Profissional de saúde indisponível",
    requestedAt: "2026-06-18",
    oldSlot: "19/06 09:00",
    status: "pendente",
    suggested: null
  },
  {
    id: 303,
    patientId: 11,
    patientName: "Hugo Almeida",
    initials: "HA",
    avatarClass: "av-slate",
    doctorId: 2,
    doctorName: "Dr. Marcos Tavares",
    reason: "Paciente solicitou",
    requestedAt: "2026-06-17",
    oldSlot: "17/06 11:00",
    status: "pendente",
    suggested: null
  },
  {
    id: 304,
    patientId: 12,
    patientName: "Sofia Martins",
    initials: "SM",
    avatarClass: "av-green",
    doctorId: 5,
    doctorName: "Dra. Júlia Mendes",
    reason: "Conflito de horário",
    requestedAt: "2026-06-17",
    oldSlot: "16/06 16:00",
    status: "pendente",
    suggested: null
  }
];

// ---------- Acompanhamento ----------
export const opportunityGroups = [
  {
    id: "retorno",
    label: "Retorno",
    count: 18,
    description: "Pacientes com retorno recomendado",
    tagVariant: "info"
  },
  {
    id: "acompanhamento",
    label: "Acompanhamento",
    count: 12,
    description: "Condições crônicas em monitoramento",
    tagVariant: "warning"
  },
  {
    id: "checkup",
    label: "Check-up",
    count: 7,
    description: "Elegíveis para check-up anual",
    tagVariant: "success"
  }
];

export const campaigns = [
  {
    id: 1,
    name: "Reativação +90 dias",
    audienceCount: 12,
    stage: "em_andamento",
    status: "Em andamento",
    createdAt: "2026-06-15"
  },
  {
    id: 2,
    name: "Check-up anual · Cardio",
    audienceCount: 8,
    stage: "rascunho",
    status: "Rascunho",
    createdAt: "2026-06-10"
  }
];

export const campaignFunnel = {
  selecionados: [
    {
      patientId: 5,
      name: "Roberto Nunes",
      initials: "RN",
      avatarClass: "av-slate",
      meta: "96 dias sem retorno"
    },
    {
      patientId: 10,
      name: "Bianca Lopes",
      initials: "BL",
      avatarClass: "av-rose",
      meta: "170 dias sem retorno"
    }
  ],
  enviada: [
    {
      patientId: 4,
      name: "Ana Beatriz R.",
      initials: "AB",
      avatarClass: "av-amber",
      meta: "Enviada há 2 dias"
    }
  ],
  respondeu: [
    {
      patientId: 11,
      name: "Hugo Almeida",
      initials: "HA",
      avatarClass: "av-slate",
      meta: "Respondeu ontem"
    }
  ],
  agendado: [
    {
      patientId: 3,
      name: "Paulo Lima",
      initials: "PL",
      avatarClass: "av-green",
      meta: "Retorno 25/06"
    }
  ]
};

// ---------- Financeiro ----------
export const financeSummary = {
  billingCents: 9648000, // faturamento do mês
  transfersCents: 6753600, // repasses (70%)
  gatewayFeeCents: 289440, // taxa gateway
  marginCents: 2605000, // margem da clínica
  ticketAvgCents: 36000,
  pendingTransfersCents: 1824000
};

export const financeEvolution = [
  { label: "Jan", value: 52 },
  { label: "Fev", value: 58 },
  { label: "Mar", value: 64 },
  { label: "Abr", value: 71 },
  { label: "Mai", value: 83 },
  { label: "Jun", value: 94, on: true }
];

export const receivables = [
  {
    id: 401,
    appointmentId: 101,
    patientName: "Maria Silva",
    doctorId: 1,
    date: "2026-06-12",
    method: "Cartão de crédito",
    grossCents: 35000,
    feeCents: 1050,
    status: "recebido"
  },
  {
    id: 402,
    appointmentId: 102,
    patientName: "José Carlos B.",
    doctorId: 2,
    date: "2026-06-11",
    method: "Pix",
    grossCents: 32000,
    feeCents: 320,
    status: "recebido"
  },
  {
    id: 403,
    appointmentId: 103,
    patientName: "Paulo Lima",
    doctorId: 3,
    date: "2026-06-10",
    method: "Cartão de crédito",
    grossCents: 30000,
    feeCents: 900,
    status: "recebido"
  },
  {
    id: 404,
    appointmentId: 104,
    patientName: "Ana Beatriz R.",
    doctorId: 4,
    date: "2026-06-09",
    method: "Pix",
    grossCents: 28000,
    feeCents: 280,
    status: "pendente"
  },
  {
    id: 405,
    appointmentId: 105,
    patientName: "Roberto Nunes",
    doctorId: 5,
    date: "2026-06-08",
    method: "Cartão de crédito",
    grossCents: 30000,
    feeCents: 900,
    status: "recebido"
  },
  {
    id: 406,
    appointmentId: 106,
    patientName: "Bianca Lopes",
    doctorId: 1,
    date: "2026-06-07",
    method: "Cartão de débito",
    grossCents: 35000,
    feeCents: 700,
    status: "estornado"
  }
];

export const transfers = [
  {
    id: 501,
    doctorId: 1,
    cycle: "16–22/06",
    appointments: 14,
    grossCents: 490000,
    amountCents: 343000,
    status: "pendente"
  },
  {
    id: 502,
    doctorId: 2,
    cycle: "16–22/06",
    appointments: 11,
    grossCents: 352000,
    amountCents: 246400,
    status: "pendente"
  },
  {
    id: 503,
    doctorId: 3,
    cycle: "16–22/06",
    appointments: 9,
    grossCents: 270000,
    amountCents: 189000,
    status: "pendente"
  },
  {
    id: 504,
    doctorId: 4,
    cycle: "16–22/06",
    appointments: 8,
    grossCents: 224000,
    amountCents: 156800,
    status: "pendente"
  },
  {
    id: 505,
    doctorId: 5,
    cycle: "16–22/06",
    appointments: 6,
    grossCents: 180000,
    amountCents: 126000,
    status: "pendente"
  }
];

export const statementEntries = [
  {
    id: 601,
    date: "2026-06-19",
    description: "Recebimento consultas (dia)",
    type: "entrada",
    amountCents: 128000
  },
  {
    id: 602,
    date: "2026-06-18",
    description: "Repasse Dra. Renata Alves",
    type: "saida",
    amountCents: 343000
  },
  {
    id: 603,
    date: "2026-06-18",
    description: "Recebimento consultas (dia)",
    type: "entrada",
    amountCents: 96000
  },
  {
    id: 604,
    date: "2026-06-17",
    description: "Taxa gateway (semana)",
    type: "saida",
    amountCents: 28944
  },
  {
    id: 605,
    date: "2026-06-16",
    description: "Recebimento Pix",
    type: "entrada",
    amountCents: 64000
  },
  {
    id: 606,
    date: "2026-06-15",
    description: "Assinatura software",
    type: "saida",
    amountCents: 19900
  }
];

export const financeBalanceCents = 1284560;

// ---------- Permissões (matriz por perfil) ----------
export const resources = [
  { key: "pacientes", label: "Pacientes" },
  { key: "agenda", label: "Agenda" },
  { key: "confirmacoes", label: "Confirmações / Reagendamentos" },
  { key: "financeiro", label: "Financeiro" },
  { key: "medicos", label: "Profissionais de saúde" },
  { key: "config", label: "Configurações" }
];

export const permissions = [
  { role: "admin", resource: "pacientes", allowed: true },
  { role: "admin", resource: "agenda", allowed: true },
  { role: "admin", resource: "confirmacoes", allowed: true },
  { role: "admin", resource: "financeiro", allowed: true },
  { role: "admin", resource: "medicos", allowed: true },
  { role: "admin", resource: "config", allowed: true },
  { role: "atendimento", resource: "pacientes", allowed: true },
  { role: "atendimento", resource: "agenda", allowed: true },
  { role: "atendimento", resource: "confirmacoes", allowed: true },
  { role: "atendimento", resource: "financeiro", allowed: false },
  { role: "atendimento", resource: "medicos", allowed: false },
  { role: "atendimento", resource: "config", allowed: false }
];

// ---------- Grade de horários (schedule) por médico ----------
export const schedules = {
  1: {
    doctorId: 1,
    duration: 30,
    gap: 0,
    validity: { from: "2026-01-01", to: "" },
    days: [
      {
        key: "seg",
        label: "Seg",
        active: true,
        start: "08:00",
        end: "12:00",
        lunch: false,
        lunchStart: "12:00",
        lunchEnd: "13:00"
      },
      {
        key: "ter",
        label: "Ter",
        active: true,
        start: "08:00",
        end: "17:00",
        lunch: true,
        lunchStart: "12:00",
        lunchEnd: "13:00"
      },
      {
        key: "qua",
        label: "Qua",
        active: true,
        start: "08:00",
        end: "12:00",
        lunch: false,
        lunchStart: "12:00",
        lunchEnd: "13:00"
      },
      {
        key: "qui",
        label: "Qui",
        active: true,
        start: "13:00",
        end: "18:00",
        lunch: false,
        lunchStart: "12:00",
        lunchEnd: "13:00"
      },
      {
        key: "sex",
        label: "Sex",
        active: true,
        start: "08:00",
        end: "16:00",
        lunch: true,
        lunchStart: "12:00",
        lunchEnd: "13:00"
      },
      {
        key: "sab",
        label: "Sáb",
        active: false,
        start: "08:00",
        end: "12:00",
        lunch: false,
        lunchStart: "12:00",
        lunchEnd: "13:00"
      },
      {
        key: "dom",
        label: "Dom",
        active: false,
        start: "08:00",
        end: "12:00",
        lunch: false,
        lunchStart: "12:00",
        lunchEnd: "13:00"
      }
    ],
    blocks: [
      { id: 1, label: "Férias", from: "2026-07-15", to: "2026-07-30" },
      {
        id: 2,
        label: "Congresso de Cardiologia",
        from: "2026-08-10",
        to: "2026-08-12"
      }
    ]
  }
};

// ---------- Dashboard (KPIs / alertas / evolução) ----------
export const dashboardKpis = {
  consultasMes: 312,
  realizadas: 268,
  pendentes: 31,
  canceladas: 13,
  pacientesAtivos: 1284,
  pacientesCadastrados: 1612,
  novosPacientes: 48,
  receitaMesCents: 9648000,
  repassesPendentesCents: 1824000,
  semRetorno: 37
};

// ---------- Contagens ao vivo (badges da sidebar) ----------
// Derivadas: acompanhamento = sem_retorno + inativos elegíveis; confirmacoes = fila.
export const sidebarBadges = {
  acompanhamento: 37,
  confirmacoes: confirmationsQueue.length
};

// ---------- Cortes de "sem retorno" ----------
export const noReturnCutoffs = [30, 60, 90];

// ============================================================
// Helpers
// ============================================================
export const formatMoney = cents =>
  ((cents || 0) / 100).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL"
  });

// Rótulos dos últimos `count` meses (atual → passado), reais — substitui os
// arrays de meses fixos ("Junho de 2026") que ficavam hardcoded nos filtros.
export const recentMonths = (count = 2, from = new Date()) =>
  Array.from({ length: count }, (_, i) => {
    const d = new Date(from.getFullYear(), from.getMonth() - i, 1);
    const label = d.toLocaleDateString("pt-BR", {
      month: "long",
      year: "numeric"
    });
    return label.charAt(0).toUpperCase() + label.slice(1);
  });

export default {
  clinics,
  clinicContext,
  units,
  operators,
  operator,
  specialties,
  doctors,
  patients,
  timelineEvents,
  notes,
  appointments,
  confirmationsQueue,
  reschedulesQueue,
  opportunityGroups,
  campaigns,
  campaignFunnel,
  financeSummary,
  financeEvolution,
  receivables,
  transfers,
  statementEntries,
  financeBalanceCents,
  resources,
  permissions,
  schedules,
  dashboardKpis,
  sidebarBadges,
  noReturnCutoffs,
  formatMoney
};
